<template>
  <div class="inline-flex min-w-px items-center gap-4">
    <TransitionGroup
      class="flex grow-0 items-center gap-2 overflow-x-scroll overflow-y-hidden"
      mode="out-in"
      tag="div"
    >
      <template v-for="(filter, filterKey) in filters">
        <RfColorTag
          v-for="(el, key) in filter"
          :key="`${filterKey}-${key}`"
          class="rf-tags-group--tag"
          :title="el"
          pill
          backgroundColor="#FFF"
          @clear="emit('remove', filterKey, key)"
        />
      </template>
    </TransitionGroup>
    <Transition mode="out-in">
      <button
        v-if="filtersLength"
        key="clear-button"
        class="rf-tags-group--clear text-body text-grey-1 shrink-0"
        @click="emit('clear')"
      >
        Clear all filters ({{ filtersLength }})
      </button>
    </Transition>
  </div>
</template>

<script setup>
import RfColorTag from "@/components/tags/RfColorTag.vue";

defineProps({
  filters: { type: Object, default: () => ({}) },
  filtersLength: { type: [Number, String], default: 0 },
});

const emit = defineEmits(["remove", "clear"]);
</script>
